import { render, staticRenderFns } from "./add-address.vue?vue&type=template&id=1d670433&scoped=true"
import script from "./add-address.vue?vue&type=script&lang=js"
export * from "./add-address.vue?vue&type=script&lang=js"
import style0 from "./add-address.vue?vue&type=style&index=0&id=1d670433&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d670433",
  null
  
)

export default component.exports